import { useCallback } from 'react';

import { useMediaCrud } from '@modules/Tributes/hooks/useMediaCrud';


type Result = {
  toTributeCreateCrud: (data: Tributes.FormData) => Promise<Tributes.Create>
}

export const useFormDataTransform = (): Result => {
  const { uploadMedia } = useMediaCrud();

  const saveFiles = useCallback(async (data: Tributes.FormData) => {
    try {
      const imageData = {
        mainPhoto: data.mainPhoto instanceof File ? (await uploadMedia.mutateAsync({ media: data.mainPhoto })).data : null,
        timeline: await Promise.all(data.timeline.map(async (event) => {
          const memoryFiles = event.draft.media || [];
          const savedFiles = await Promise.all(memoryFiles.map(async (file) => {
            if (file instanceof File) {
              return (await uploadMedia.mutateAsync({ media: file })).data;
            }
            return [file];
          }));
          return {
            media: savedFiles,
          };
        })),
      };
      return imageData;
    } catch (error) {
      console.error('Error saving files:', error);
      throw error;
    }
  }, [uploadMedia]);

  const toTributeCreateCrud = useCallback(async (data: Tributes.FormData) => {
    const imageData = await saveFiles(data);

    return {
      pet: data.pet,
      mainPhoto: data.mainPhoto instanceof File
        ? (imageData.mainPhoto?.[0].id ?? null)
        : (data.mainPhoto as any)?.id ?? null,
      memories: data.timeline.map((event, index) => ({
        media: imageData.timeline[index].media.map(file => file[0].id),
        date: event.draft.date,
        text: event.draft.text,
      })),
    };
  }, [saveFiles]);

  return { toTributeCreateCrud };
};